const ContentType = Object.freeze({
  SOCIAL_WEB: 'SocialWeb',
  AUDIENCE_MARKETING: 'AudienceMarketing',
  A3D_SUPPLEMENT: 'A3DSupplement'
})
export default ContentType
export type ContentTypeString = typeof ContentType[keyof typeof ContentType]
// RESERVE BELOW
